import React, { Component } from 'react'
import classes from './VideoPlayer.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import * as actions from 'store/actions/index';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCut, faStepForward, faStepBackward, faFileAlt, faForward, faBackward } from '@fortawesome/free-solid-svg-icons';
import { injectIntl } from 'react-intl';
import ClipUtil from 'Flow2/util/Clip';
import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as Controls from 'Flow2/config/Controls';

import MediaFile from 'Flow2/util/MediaFile';

import PlayerControls from './Controls/VideoPlayerControls';

import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import {
	subStringAfter,
	isSdk
} from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import TvPlayer from 'Flow2/components/AdvancedBox/AdvancedUI/TvPlayer/TvPlayer';

import Swal from 'sweetalert2';


class VideoPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = { ...this.initState(props) }
		this.video = React.createRef();
	};

	initState = (props) => {
		const state = {
			setControls: true,
			currentTime: 0,
		}

		return state;
	}

	componentWillReceiveProps = (nextProps) => {
		if (this.props.clip.id !== nextProps.clip.id) {
			const state = { ...this.state, ...this.initState(nextProps) }
			this.setState({ ...state });

			if (!this.video) {
				this.video = React.createRef();
			}
		}
	}

	onTimeUpdate = (evt) => {
		this.setState({ currentTime: evt.target.currentTime });

		// callback to parent to send current player time
		if (this.props.handleTimeUpdate) {
			this.props.handleTimeUpdate(evt.target.currentTime);
		}
	}

	onTimeBasedMeta = () => {
		this.props.timeBasedMeta();
	}

	componentDidMount() {
		console.log("componentDidMount");
		this.setupPlayerControls();
	}

	componentDidUpdate(prevProps) {
		// indicator from parent to set current player time
		// callback to parent to show current time is set
		if (this.props.setCurrentTime) {
			this.video.current.currentTime = this.props.currentTime;
			this.props.handleSetCurrentTime();
		}

		// NOTE: check if setup needed here or only in componentDidMount
		//this.setupPlayerControls();
	}

	setupPlayerControls = () => {
		if (!this.state.setControls) { return; }

		// prevent context menu must be set via ReactRef
		// Günther: removed ' && !this.video.current.oncontextmenu' in React version 16.x
		if (this.video.current && !this.video.current.oncontextmenu) {
			this.video.current.oncontextmenu = (event) => {
				event.preventDefault();
			}
		}

		if (this.video.current) {
			this.video.current.addEventListener('keydown', (evt) => {
				switch (true) {
					case evt.code === "ArrowUp":
						evt.preventDefault();
						evt.stopPropagation();
						evt.stopImmediatePropagation();
						this.video.current.currentTime += 1;
						break;
					case evt.code === "ArrowDown":
						evt.preventDefault();
						evt.stopPropagation();
						evt.stopImmediatePropagation();
						this.video.current.currentTime -= 1;
						break;
					default:
						break;
				}
			});
		}

		// show and remove player controls on mouseover
		if (this.video.current) {
			this.video.current.addEventListener('mouseenter', (evt) => {
				this.video.current.setAttribute("controls", "controls");
				//this.video.current.classList.remove("hideControls");
			});
			this.video.current.addEventListener('mouseleave', (evt) => {
				this.video.current.removeAttribute("controls");
				//this.video.current.classList.add("hideControls");
			});
		}

		this.setState({ setControls: false });
	}

	canDownload = () => {
		// always disable download in player
		return "nodownload";

		if (!PH.hasFieldPermission({ user: this.props.user, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "download")) return "nodownload";
		if (!PH.showControl(this.props.config, Controls.CTL_DOWNLOAD)) return "nodownload";

		return "";
	}

	getSubtitleLabel = (tags) => {
		if (tags) {
			let language = tags.split(',').filter(item => item.includes("language"));
			if (language && language.length) language = subStringAfter(language[0], 'language_');
			return language;
		}
		return tags;
	}

	getTracks = () => {
		const tracks = [];
		this.props.clip.mediafiles.forEach(file => {
			// check if file is subtitle and extract file extension to check 'vtt' format
			if (file.tags && file.tags.indexOf('subtitles') !== -1 && file.filename.split('.').pop() === 'vtt') {
				let lang = this.getSubtitleLabel(file.tags)
				if (!tracks.length) {
					tracks.push(
						<track label={lang} kind="subtitles" srclang={lang} src={file.url} default />
					);
				} else {
					tracks.push(
						<track label={lang} kind="subtitles" srclang={lang} src={file.url} />
					);
				}
			}
		});
		return tracks;
	}

	renderControls = () => {
		if (!this.props.controls.length) { return ""; }

		return (
			<PlayerControls
				key={"control_" + this.props.mediafile.id}
				{...this.props}
				video={this.video.current}
				mediafile={this.props.mediafile} />
		);
	}

	render = () => {
		const download = this.canDownload();

		if (isSdk()) return (
			<div>
				<TvPlayer
					poster={this.props.clip.mainthumbnail ? MediaFile.localURL() + this.props.clip.mainthumbnail + '&width=750&height=420' : null}
					src={this.props.mediafile ? MediaFile.localURL() + this.props.mediafile.url : null} />
			</div>
		)
		return (
			<div className="relative">
				<video
					className={classes.Player}
					key={this.props.mediafile.id}
					ref={this.video}
					onTimeUpdate={this.onTimeUpdate}
					controls="controls"
					poster={this.props.clip.mainthumbnail ? MediaFile.localURL() + this.props.clip.mainthumbnail + '&width=750&height=420' : null}
					type="video/mp4"
					controlsList={download} >
					<source src={this.props.mediafile ? MediaFile.localURL() + this.props.mediafile.url : null}></source>
					{this.getTracks()}
				</video>

				{this.renderControls()}

				{/*<PlayerControls
					key={"control_" + this.props.mediafile.id}
					{...this.props}
					video={this.video.current}
					mediafile={this.props.mediafile} />*/}

			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.auth.user,
		transcoding: state.clipList.transcoding,
		config: state.ui.config
	}
}


const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VideoPlayer));
